// removed by extract-text-webpack-plugin
module.exports = {"searchPage":"bz_b0","body":"bz_b1","ctaContainer":"bz_b2","cta":"bz_b3"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventSearchRecommendRace/styles.module.css
// module id = 1106
// module chunks = 27